"use client"
import { useBlockExplorer } from "@opensea/app-kit"
import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { useDateTimeFormatter } from "@opensea/i18n"
import { Link } from "@opensea/next-ui-kit"
import { FlexCenter, Tooltip } from "@opensea/ui-kit"
import { ArrowOutward } from "@opensea/ui-kit/icons"
import { ActivityFeedLiveTimestampFragment } from "./ActivityFeedLiveTimestamp.fragment"
import type { LiveTimestampProps } from "./LiveTimestamp"
import { LiveTimestamp } from "./LiveTimestamp"

type Props = {
  activity: FragmentOf<typeof ActivityFeedLiveTimestampFragment>
  showArrow?: boolean
} & Pick<LiveTimestampProps, "display">

export function ActivityFeedLiveTimestamp({
  activity: activityKey,
  display,
  showArrow = false,
}: Props) {
  const activity = readFragment(ActivityFeedLiveTimestampFragment, activityKey)
  const blockExplorer = useBlockExplorer(activity.chain.identifier)
  const dateFormat = useDateTimeFormatter()
  const timestamp = new Date(activity.eventTime)
  const liveTimestamp = <LiveTimestamp date={timestamp} display={display} />

  if (activity.transactionHash) {
    return (
      <Tooltip content={dateFormat(timestamp, { display: "datetime-numeric" })}>
        <Link
          href={blockExplorer.getTransactionUrl(activity.transactionHash)}
          onClick={event => {
            event.stopPropagation()
          }}
          variant="unstyled"
        >
          <FlexCenter className="gap-1">
            {liveTimestamp}
            {showArrow ? <ArrowOutward size={14} /> : null}
          </FlexCenter>
        </Link>
      </Tooltip>
    )
  }
  return (
    <Tooltip content={dateFormat(timestamp, { display: "datetime-numeric" })}>
      {liveTimestamp}
    </Tooltip>
  )
}
